import { z } from 'zod';
import { LOCALE_CODES } from '../i18n/locales.js';
import type { Locale } from '../i18n/locales.js';

/**
 * Zod-схемы контракта настроек языка (work-025, расширено work-026).
 *
 * GET /me/locale  → MeLocaleResponse
 * PATCH /me/locale ← UpdateLocaleBody → MeLocaleResponse
 */

/** Допустимые значения locale — зеркало реестра SUPPORTED_LOCALES (i18n/locales). */
export const LocaleSchema = z.enum(LOCALE_CODES);

/** Compile-time проверка: LocaleSchema ↔ Locale из реестра — совпадают полностью. */
type _Assert = z.infer<typeof LocaleSchema> extends Locale
  ? Locale extends z.infer<typeof LocaleSchema>
    ? true
    : never
  : never;
const _localeAssert: _Assert = true;
void _localeAssert;

/** Ответ GET/PATCH /me/locale. */
export const MeLocaleResponse = z
  .object({
    locale: LocaleSchema.nullable(),
  })
  .strict();
export type MeLocaleResponse = z.infer<typeof MeLocaleResponse>;

/** Тело PATCH /me/locale. */
export const UpdateLocaleBody = z
  .object({
    locale: LocaleSchema,
  })
  .strict();
export type UpdateLocaleBody = z.infer<typeof UpdateLocaleBody>;
